import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Image } from "../image";
import DateModalComponent from "./dateModal";
import DaumPostcode from "react-daum-postcode";
import CloseIcon from "../../icon/closeIcon";
import CustomButton from "../customButton";
import { updatePlumberReceiptDetail } from "../../../API/AppRepository";
import { useParams } from "react-router-dom";
import { PlumberFormData } from "../../../types/plumber";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 20px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ButtonArea = styled.div`
  width: 100%;

  display: flex;
  justify-content: space-between;

  /* 모바일*/
  @media (max-width: 767px) {
    height: 40px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    height: 60px;
  }

  /* PC */
  @media (min-width: 1200px) {
    height: 70px;
  }
`;

const LeftBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
`;

const OptionName = styled.div`
  font-weight: 500;
  /* 모바일*/
  @media (max-width: 767px) {
    font-size: 16px;
    margin-left: 6px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    font-size: 20px;
    margin-left: 10px;
  }

  /* PC */
  @media (min-width: 1200px) {
    font-size: 20px;
    margin-left: 16px;
  }
`;

const Label = styled.label`
  display: block;
  margin-bottom: 14px;
  font-weight: bold;
`;

const Input = styled.input`
  width: 100%;

  border: 1px solid #ddd;
  border-radius: 6px;
  margin-bottom: 16px;
  outline: none;
  &:focus {
    border: 2px solid #0c8ce9;
  }
  /* 모바일*/
  @media (max-width: 767px) {
    font-size: 14px;
    padding: 10px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    font-size: 18px;
    padding: 16px;
  }

  /* PC */
  @media (min-width: 1200px) {
    font-size: 20px;
    padding: 20px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

const Row = styled.div`
  margin-bottom: 16px;
`;

const OptionRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding: 12px;
  border-radius: 6px;
  outline: 1px solid #ccc;
`;
const DateWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const AddressWrapper = styled.div`
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden; // ✅ 스크롤 방지

  /* 모바일*/
  @media (max-width: 767px) {
    padding: 20px 10px;
    width: 100%;
    height: 600px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    padding: 30px 30px;
    width: 600px;
    height: 700px;
  }

  /* PC */
  @media (min-width: 1200px) {
  }
  padding: 30px 30px;
  width: 700px;
  height: 800px;
`;

const PriceInput = styled.input`
  margin-left: auto;
  text-align: right;

  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
  &:focus {
    border: 2px solid #0c8ce9;
  }

  /* 모바일*/
  @media (max-width: 767px) {
    width: 100%;
    padding: 8px;
    font-size: 16px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    width: 240px;
    padding: 12px;
    font-size: 18px;
  }

  /* PC */
  @media (min-width: 1200px) {
    width: 300px;
    padding: 14px;
    font-size: 20px;
  }
`;

const StatusBadge = styled.span<{ $status: string }>`
  display: inline-block;
  padding: 12px 20px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ $status }) => {
    switch ($status) {
      case "접수완료":
        return "#3da5f5";
      case "상담토스":
        return "#0ea5e9";
      case "상담승인":
        return "#06b6d4";
      case "상담완료":
        return "#22c55e";
      case "상담반려":
        return "#f97316";
      case "계약미승인":
        return "#a855f7";
      case "계약완료":
        return "#9333ea";
      case "취소":
        return "#fe4a18";
      default:
        return "#6b7280";
    }
  }};
  background-color: ${({ $status }) => {
    switch ($status) {
      case "접수완료":
        return "#e6f4ff";
      case "상담토스":
        return "#e0f2fe";
      case "상담승인":
        return "#cffafe";
      case "상담완료":
        return "#dcfce7";
      case "상담반려":
        return "#ffedd5";
      case "계약미승인":
        return "#f3e8ff";
      case "계약완료":
        return "#ede9fe";
      case "취소":
        return "#ede9fe";
      default:
        return "#f3f4f6";
    }
  }};
`;
const CloseBtnBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: #8080802f;

  /* 모바일*/
  @media (max-width: 767px) {
    width: 24px;
    height: 24px;
    border-radius: 6px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    width: 30px;
    height: 30px;
    border-radius: 8px;
  }

  /* PC */
  @media (min-width: 1200px) {
    width: 34px;
    height: 34px;
    border-radius: 6px;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;

  /* 모바일*/
  @media (max-width: 767px) {
    height: 30px;
  }

  /* 태블릿*/
  @media (min-width: 768px) and (max-width: 1199px) {
    height: 50px;
  }

  /* PC */
  @media (min-width: 1200px) {
    height: 60px;
  }
`;

interface Props {
  form: PlumberFormData;
  setForm: React.Dispatch<React.SetStateAction<PlumberFormData>>;
  optionList: any[];
  selectedOptions: string[];
  setSelectedOptions: React.Dispatch<React.SetStateAction<string[]>>;
  optionPrices: Record<string, string>;
  setOptionPrices: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  onOpenDateModal: () => void;
}

const PlumberDetailBasicInfo = ({
  form,
  setForm,
  optionList,
  selectedOptions,
  setSelectedOptions,
  optionPrices,
  setOptionPrices,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const { id } = useParams();

  const handleUpdateReceipt = async () => {
    const result = await updatePlumberReceiptDetail(id, form);
    alert("업데이트가 완료되었습니다.");
  };

  const handleCompleteAddress = (data: any) => {
    const fullAddress = data.address;
    const zipCode = data.zonecode;

    setForm((prev) => ({
      ...prev,
      address: fullAddress,
      zipCode: zipCode,
    }));

    setIsAddressModalOpen(false);
  };

  const handleChange = (
    field: keyof PlumberFormData,
    value: string | number
  ) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleCheck = (label: string) => {
    const base = label;
    setSelectedOptions((prev) => {
      const updated = prev.includes(base)
        ? prev.filter((opt) => opt !== base)
        : [...prev, base];
      if (prev.includes(base)) {
        setOptionPrices((prices) => ({ ...prices, [base]: "0" }));
      }
      return updated;
    });
  };

  const handlePriceChange = (label: string, inputValue: string) => {
    // 숫자만 필터링
    const numericOnly = inputValue.replace(/[^0-9]/g, "");

    // 상태에는 실제 숫자만 저장
    setOptionPrices((prev) => ({
      ...prev,
      [label]: numericOnly,
    }));
  };

  const handleDateSelect = (date: string) => {
    setForm((prev) => ({ ...prev, workDate: date }));
    setIsModalOpen(false);
  };

  const getStatusLabel = (code: string): string => {
    switch (code) {
      case "11":
        return "접수완료";
      case "12":
        return "상담토스";
      case "13":
        return "상담승인";
      case "14":
        return "상담완료";
      case "19":
        return "상담반려";
      case "21":
        return "계약미승인";
      case "22":
        return "계약";
      case "CA":
        return "취소";
      default:
        return "알수없음";
    }
  };
  useEffect(() => {
    const total = Object.values(optionPrices)
      .map((v) => Number(v) || 0)
      .reduce((acc, cur) => acc + cur, 0);
    setForm((prev) => ({ ...prev, totalPrice: total }));
  }, [optionPrices]);

  useEffect(() => {
    const updatedOptions = selectedOptions.map((name) => ({
      name,
      price: Number(optionPrices[name]) || 0,
    }));

    setForm((prev) => ({
      ...prev,
      options: updatedOptions,
    }));
  }, [selectedOptions, optionPrices]);

  return (
    <Wrapper>
      <Container>
        <div
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "end",
            }}
          >
            <Label>상태</Label>
            <StatusBadge $status={getStatusLabel(form.status)}>
              {getStatusLabel(form.status)}
            </StatusBadge>
          </div>
        </div>
        <Grid>
          <div>
            <Label>고객명 *</Label>
            <Input
              value={form.name}
              onChange={(e) => handleChange("name", e.target.value)}
              placeholder=""
            />
          </div>
          <div>
            <Label>작업예정일 *</Label>
            <Input
              readOnly
              value={form.workDate ? form.workDate.slice(0, 10) : ""}
              onClick={() => setIsModalOpen(true)}
            />
          </div>
        </Grid>

        <Grid>
          <div>
            <Label>연락처 *</Label>
            <Input
              value={form.contact}
              onChange={(e) => handleChange("contact", e.target.value)}
            />
          </div>
          <div>
            <Label>상품종류</Label>
            <Input
              readOnly
              disabled
              value={"배관케어(P01532)"}
              onChange={(e) => handleChange("itemCode", e.target.value)}
            />
          </div>
        </Grid>

        <Label>작업주소 *</Label>
        <Input
          readOnly
          value={`${form.address}${form.zipCode ? ` (${form.zipCode})` : ""}`}
          onClick={() => setIsAddressModalOpen(true)}
          placeholder="주소를 검색해주세요"
        />
        <Label>상세주소 *</Label>
        <Input
          value={form.addressDetail}
          onChange={(e) => handleChange("addressDetail", e.target.value)}
        />

        {isModalOpen && (
          <DateWrapper>
            <AddressWrapper>
              <DateModalComponent
                initialDate={form.workDate}
                onSelect={handleDateSelect}
                onClose={() => setIsModalOpen(false)}
              />
            </AddressWrapper>
          </DateWrapper>
        )}

        {isAddressModalOpen && (
          <DateWrapper>
            <AddressWrapper>
              <ModalHeader>
                <CloseBtnBox>
                  <CloseIcon
                    onClick={() => setIsAddressModalOpen(false)}
                    height={"60%"}
                    fill={"#969696"}
                  />
                </CloseBtnBox>
              </ModalHeader>
              <DaumPostcode
                onComplete={handleCompleteAddress}
                style={{ width: "100%", height: "90%" }} // ✅ 조절된 크기
              />
            </AddressWrapper>
          </DateWrapper>
        )}

        <Row>
          <Label>옵션 정보</Label>
          {optionList.map((option) => {
            const base = option.name;
            const isChecked = selectedOptions.includes(base);
            return (
              <OptionRow key={option.name}>
                <LeftBox
                  onClick={() => handleCheck(base)}
                  style={{ cursor: "pointer" }}
                >
                  <Image
                    src={`/icon/${isChecked ? "checked" : "unchecked"}.png`}
                    alt="체크박스"
                    width={"20px"}
                    height={"20px"}
                  />

                  <OptionName>
                    {option.name}
                    {option.size ? `(${option.size})` : option.size}
                  </OptionName>
                </LeftBox>

                <PriceInput
                  disabled={!isChecked}
                  value={
                    optionPrices[base]
                      ? Number(optionPrices[base]).toLocaleString()
                      : 0
                  }
                  onChange={(e) => handlePriceChange(base, e.target.value)}
                />
                <span style={{ marginLeft: 8 }}>원</span>
              </OptionRow>
            );
          })}
        </Row>

        <Label>메모</Label>
        <Input
          as="textarea"
          value={form.memo}
          onChange={(e) => handleChange("memo", e.target.value)}
          placeholder="작업시 메모사항을 적으세요."
        />
      </Container>
      <ButtonArea>
        <CustomButton
          fontWeight="500"
          width="100%"
          height="100%"
          text="견적서 저장하기"
          $bgColor="#0C8CE9"
          onClick={() => {
            handleUpdateReceipt();
          }}
        ></CustomButton>
      </ButtonArea>
    </Wrapper>
  );
};

export default PlumberDetailBasicInfo;
